import { View } from 'react-native';

import {
  PartnerLineItemHeroActions,
  PartnerLineItemHeroButton,
  PartnerLineItemHeroByline,
  PartnerLineItemHeroContainer,
  PartnerLineItemHeroContent,
  PartnerLineItemHeroDescription,
  PartnerLineItemHeroDetails,
  PartnerLineItemHeroImage,
  PartnerLineItemHeroPartnerImage,
  PartnerLineItemHeroProductImage,
  PartnerLineItemHeroProductName,
  PartnerLineItemHeroTitle,
} from './components';

export const PartnerLineItemHero = {
  Actions: PartnerLineItemHeroActions,
  Button: PartnerLineItemHeroButton,
  Byline: PartnerLineItemHeroByline,
  Container: PartnerLineItemHeroContainer,
  Content: PartnerLineItemHeroContent,
  Description: PartnerLineItemHeroDescription,
  Details: PartnerLineItemHeroDetails,
  Heading: View,
  Image: PartnerLineItemHeroImage,
  PartnerImage: PartnerLineItemHeroPartnerImage,
  ProductImage: PartnerLineItemHeroProductImage,
  ProductName: PartnerLineItemHeroProductName,
  Title: PartnerLineItemHeroTitle,
};
